import { UserManager, WebStorageStateStore } from "oidc-client-ts";

let userManagerInstance = null;

/**
 * OIDC user manager settings derived from build-time env (CRA).
 * Configure your IdP client with the same redirect URI as REACT_APP_OIDC_REDIRECT_URI
 * (or origin + REACT_APP_OIDC_REDIRECT_PATH).
 */
export function getOidcSettings() {
  const redirectPath =
    process.env.REACT_APP_OIDC_REDIRECT_PATH || "/auth/callback";
  const postLogoutPath =
    process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_PATH ||
    "/auth/logout-callback";

  const redirectUri =
    process.env.REACT_APP_OIDC_REDIRECT_URI ||
    `${window.location.origin}${redirectPath}`;

  const postLogoutRedirectUri =
    process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI ||
    (postLogoutPath === "/"
      ? `${window.location.origin}/`
      : `${window.location.origin}${postLogoutPath}`);

  const scope =
    process.env.REACT_APP_OIDC_SCOPE ||
    "openid profile email offline_access";

  return {
    authority: process.env.REACT_APP_OIDC_AUTHORITY || "",
    client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "",
    redirect_uri: redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri,
    response_type: "code",
    scope,
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: true,
  };
}

export function getUserManager() {
  if (userManagerInstance) {
    return userManagerInstance;
  }

  const settings = {
    ...getOidcSettings(),
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };

  userManagerInstance = new UserManager(settings);
  return userManagerInstance;
}
